import { ITEM, type Items, type ItemType } from '../types';

const bfsTraverse = (items: Items, callback: (item: ItemType) => boolean): Items => {
	const queue = [...items];
	while (queue.length > 0) {
		const currentItem = queue.shift()!;
		if (callback(currentItem)) {
			break;
		}
		if (currentItem.type === ITEM.MENU && currentItem.childItems) {
			queue.push(...currentItem.childItems);
		}
	}
	return items;
};

export const addItemInPlaceHelper = (
	items: Items,
	item: ItemType,
	parentId?: string,
	position?: number,
): Items => {
	const addItemToParentInPlace = (
		itemsToTraverse: Items,
		parentId: string,
		item: ItemType,
		position?: number,
	): Items => {
		return bfsTraverse(itemsToTraverse, (currentItem) => {
			if (currentItem.itemId === parentId && currentItem.type === ITEM.MENU) {
				if (position !== undefined && position >= 0 && position <= currentItem.childItems!.length) {
					currentItem.childItems!.splice(position, 0, item);
				} else {
					currentItem.childItems = [...(currentItem.childItems || []), item];
				}
				return true;
			}
			return false;
		});
	};
	let newItems: Items;
	if (parentId !== undefined) {
		newItems = addItemToParentInPlace(items, parentId, item, position);
	} else {
		const itemsLength = items.length;
		const newPosition =
			position !== undefined && position >= 0 && position <= itemsLength ? position : itemsLength;
		newItems = [...items];
		newItems.splice(newPosition, 0, item);
	}
	return newItems;
};

export const updateItemInPlaceHelper = (items: Items, updatedItem: ItemType): Items => {
	return bfsTraverse(items, (currentItem) => {
		if (currentItem.itemId === updatedItem.itemId) {
			Object.assign(currentItem, updatedItem);
			return true;
		}
		return false;
	});
};

export const deleteItemInPlaceHelper = (items: Items, itemId: string): Items => {
	return items
		.map((item) => {
			if (item.type === ITEM.MENU && item.childItems) {
				item.childItems = deleteItemInPlaceHelper(item.childItems, itemId);
			}
			return item;
		})
		.filter((item) => item.itemId !== itemId);
};
